import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatLowercase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	fill: "none",
	viewBox: "0 0 20 21",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M11.75 5.75v10.5m-2.5-7.5v7.5m8.5-3.75c0 2.071-1.343 3.75-3 3.75s-3-1.679-3-3.75c0-2.071 1.343-3.75 3-3.75s3 1.679 3 3.75Zm-15.5 0c0 2.071 1.567 3.75 3.5 3.75s3.5-1.679 3.5-3.75c0-2.071-1.567-3.75-3.5-3.75s-3.5 1.679-3.5 3.75Z"
	})]
});
const ForwardRef = forwardRef(SvgFormatLowercase);
export { ForwardRef as ReactComponent };
